export default __webpack_public_path__ + "images/937054ac1864fcc7db6f954981abc1da.svg";